import React from "react";
import DepartementPage from "./DepartementPage";

const AMOParis75 = () => {
  return <DepartementPage dept="paris" />;
};

export default AMOParis75;
